import { render, staticRenderFns } from "./LoginModalApp.vue?vue&type=template&id=56c3dd54&"
import script from "./LoginModalApp.vue?vue&type=script&lang=js&"
export * from "./LoginModalApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports